module.exports = __webpack_public_path__ + "img/Delete.5814b1c0.svg";